// extracted by mini-css-extract-plugin
module.exports = {"lead-avatar":"lead-avatar__lead-avatar___3O37s"};